import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const ProbeIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 48 48" width="48" height="48" {...props}>
    <rect width="48" height="48" rx="24" fill="#E9E9E6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3175 34.8495L11.849 36.151L13.1508 32.6825L26.0802 19.753L28.2472 21.92L15.3175 34.8495ZM38.055 14.3619L33.6384 9.94512C33.4833 9.79002 33.2697 9.70719 33.0518 9.71484C32.8328 9.72317 32.6271 9.82199 32.4841 9.98833L25.5019 18.1028L11.9161 31.6887C11.8364 31.7684 11.775 31.8638 11.7354 31.9692L9.76443 37.2213C9.65616 37.5106 9.72662 37.8365 9.94518 38.0551C10.0955 38.2054 10.2968 38.2858 10.5023 38.2858C10.5953 38.2858 10.6889 38.2694 10.7789 38.2356L16.0308 36.2649C16.1362 36.2253 16.2319 36.1638 16.3111 36.0843L29.8965 22.4989L35.8151 17.4066C36.1446 17.123 36.182 16.6255 35.8984 16.2955C35.6145 15.9657 35.1175 15.9282 34.7871 16.2122L29.4015 20.846L27.1541 18.5985L31.3855 13.681L33.2252 15.5207C33.3787 15.6747 33.5806 15.7517 33.782 15.7517C33.9837 15.7517 34.1852 15.6747 34.3391 15.521C34.6468 15.2133 34.6468 14.7144 34.3391 14.4067L32.4159 12.4833L33.1245 11.6597L36.9408 15.4762C37.2487 15.7839 37.7473 15.7836 38.055 15.4762C38.3627 15.1685 38.3627 14.6696 38.055 14.3619Z"
      fill="#747778"
    />
  </IconWrapper>
);

export default ProbeIcon;
